import React, { useState } from 'react';
import { Button, Icon, Input, Label, Dimmer, Loader } from 'semantic-ui-react';
import './style.less';

const StripeCreditCard = ({ type }) => {
    //Type is stripe card brand.
    //Possible values amex, diners, discover, jcb, mastercard, unionpay, visa, or unknown. Except unionpay we have all other card icons in semantic ui icons. For unionpay and 'unknown' generic card icon can be shown.
    const ccIconName =
        type === 'unknown' || type === 'unionpay' ? 'credit card' : type === 'diners' ? 'cc diners club' : `cc ${type}`;
    return <Icon name={ccIconName} />;
};

const DisplaySubscriptionPaymentMethod = ({ paymentMethod, isReadOnly, openEditToggle, deleteCard }) => {
    const [loading, setLoading] = useState(false);

    return (
        <div className="subscription-payment-details">
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            <div className="payment-detail">
                <div className="card-details">
                    <p className="typography-body4 card-name">{paymentMethod.billing_details.name} </p>
                    <p className="typography-body4 card-type">{paymentMethod.type === 'card' ? 'Credit Card' : ''}</p>
                    <p className="typography-body4 card-number">
                        <StripeCreditCard type={paymentMethod.card.brand} />
                        •••• {paymentMethod.card.last4}
                    </p>
                    <p className="typography-body4 card-expiry">
                        {paymentMethod.card.exp_month}/{paymentMethod.card.exp_year}
                    </p>
                    <p className="typography-body4 edit-card">
                        {isReadOnly ? (
                            <></>
                        ) : (
                            <Icon
                                name="trash"
                                onClick={async () => {
                                    setLoading(true);
                                    await deleteCard(paymentMethod.id);
                                    setLoading(false);
                                }}
                            />
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DisplaySubscriptionPaymentMethod;
